module.exports = __webpack_public_path__ + "media/images/dashboard/light/tile_icon_adwords_call_volume-0858a55b4d2b0c694032d19a46667495.png";